/**
 * 组件使用场景：查看报表
 * */
import React, { Component } from 'react';
import { ConfigProvider, Modal, Table, Button } from 'antd';
import ReactDOM from 'react-dom';
import zh_CN from 'antd/es/locale/zh_CN';
import { connect, Provider } from '@souche-f2e/muji';
import store, { dispatch } from '@@/store';
import { dealListValueShow } from '@/shared/functions';
import reportStyle from '../_style/reportViewModal.less';
const mapStateToProps = (rootState) => ({
    report: rootState.reportCreate,
});
class ReportView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemWidth: 220,
        };
    }
    cancel() {
        dispatch.reportCreate.SET_STATE({
            showReport: false,
        });
        dispatch.reportCreate.CLOSE_REPORT_VIEW({});
    }
    afterClose() {
        dispatch.reportCreate.CLOSE_REPORT_VIEW({});
    }
    tableUpdate(index) {
        dispatch.reportCreate.showReportIndex(index);
    }
    _renderModalFooter() {
        const { reportShowId, reportFormUrl, reportStatus } = this.props.report;
        return (<div className={reportStyle.modal_footer}>
        <Button onClick={() => {
            this.cancel();
            dispatch.router.push({
                path: '/DataStatistics/ReportList/reportCreate',
                query: {
                    id: reportShowId,
                },
            });
        }}>
          复制
        </Button>
        {reportStatus === 2 && <Button type={'primary'} onClick={() => {
            location.href = reportFormUrl;
        }}>
            下载
          </Button>}
      </div>);
    }
    dealColumns(reportColumns) {
        const fixedKey = ['startDt', 'sessNum', 'sessName', 'serialNumber', 'buyerName'];
        const { itemWidth } = this.state;
        const tableWidth = 1150;
        const columnsLength = reportColumns.length;
        if (columnsLength * itemWidth < tableWidth) {
            return reportColumns.map((item) => {
                return Object.assign(Object.assign({}, item), { width: itemWidth });
            });
        }
        return reportColumns.map((item) => {
            const key = item.dataIndex;
            const needFixed = fixedKey.includes(key);
            return Object.assign(Object.assign({}, item), { fixed: needFixed ? 'left' : undefined, width: itemWidth });
        });
    }
    render() {
        const { showReport, reportColumns, reportTableData, reportCurrent, reportPageSize, reportTableTotal, reportFormName, } = this.props.report;
        const columns = this.dealColumns(reportColumns);
        const { itemWidth } = this.state;
        const tableScrollX = columns.length === 0 ? undefined : columns[0].fixed ? `${columns.length * itemWidth}px` : undefined;
        return (<ConfigProvider locale={zh_CN}>
        <Modal visible={showReport} title={'报表预览'} footer={this._renderModalFooter()} 
        // afterClose={this.afterClose}
        onCancel={this.cancel} width={1200}>
          <div className={reportStyle.report_title}>{reportFormName || 'ceshi'}</div>
          <Table className={'report_view'} scroll={{ x: tableScrollX, y: 400 }} bordered columns={columns} dataSource={dealListValueShow({
            gistData: reportColumns,
            data: reportTableData,
        })} pagination={{
            size: 'small',
            current: reportCurrent,
            pageSize: reportPageSize,
            total: reportTableTotal,
            onChange: this.tableUpdate,
        }}/>
        </Modal>
      </ConfigProvider>);
    }
}
ReportView.defaultProps = {};
const ReportViewComponent = connect(mapStateToProps)(ReportView);
/**
 * API
 * */
let componentRef = '';
const createAbortiveAuction = () => {
    const div = document.createElement('div');
    document.body.appendChild(div);
    const refFn = (ref) => {
        componentRef = ref;
    };
    const Create = React.createElement;
    const component = (<Provider store={store}>
      {Create(ReportViewComponent, {
        ref: refFn,
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
const showReport = (id) => {
    if (!componentRef) {
        createAbortiveAuction();
    }
    dispatch.reportCreate.showReport(id);
};
export default showReport;
